import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toTitleCase } from '@iotv/datamodel-core';
import { Checkbox, Stack, Switch, Typography } from '@mui/material';
import { standardOutlinedStackProps } from './cosmetics';
const debug = process.env.REACT_APP_DEBUG && false;
// type SolenoidControllerOptionsKeys = keyof typeof solenoidControllerOptionsTemplate
export const getBitMapControlFC = (byteObjectRepresentationTemplate) => ({ state, dispatch, stateKey: key, label, maxWidth }) => {
    const { valueSettings } = state;
    const handleBitChange = (k, set, currentMap) => {
        const clonedMap = { ...currentMap };
        console.log(`TEMP: handleBitChange`, { k, set, currentMap, clonedMap });
        clonedMap[k] = set ? 1 : 0;
        dispatch({ type: 'UpdateMap', update: { key, v: clonedMap } });
    };
    if (!valueSettings[key]) {
        return _jsx(Typography, { children: `Can't find key ${key}` });
    }
    else {
        const { include, value } = valueSettings[key];
        if (typeof value === 'object') {
            const currentMap = value;
            const bitControls = Object.entries(byteObjectRepresentationTemplate).map(([k, v]) => {
                return (_jsxs(Stack, { direction: 'row',
                    alignItems: 'center',
                    gap: 1,
                    width: maxWidth,
                    boxSizing: 'border-box',
                    paddingInline: 1.5,
                    borderRadius: 1,
                    border: (t) => `1px solid ${t.palette.action.disabled}`,
                    sx: {
                        [`&:hover`]: {
                            border: include ? (t) => `1px solid ${t.palette.action.active}` : undefined,
                        },
                    }, children: [_jsx(Switch, { size: 'small',
                            disabled: !include,
                            checked: currentMap[k] === 1,
                            onChange: (_, checked) => {
                                handleBitChange(k, checked, currentMap);
                            } }), _jsx(Typography, { color: include ? undefined : 'textDisabled', sx: { paddingBlock: 1 }, children: `${toTitleCase(k)} ${currentMap[k] === 1 ? 'on' : 'off'}` })] }, key));
            });
            return (_jsx(Stack, { ...standardOutlinedStackProps, width: maxWidth, children: _jsxs(Stack, { direction: 'row', alignItems: 'flex-start', gap: 1, width: undefined, children: [_jsx(Checkbox, { checked: include,
                            sx: { padding: 0 },
                            onClick: () => {
                                dispatch({ type: 'TogglePresence', update: { key } });
                            } }), _jsx(Typography, { paddingBlock: 1, children: `${label}` }), _jsx(Stack, { direction: 'row', children: _jsx(Stack, { direction: 'row', flexWrap: 'wrap', gap: 1, children: bitControls }) })] }) }));
        }
        else {
            return _jsx(Typography, { children: `Not number at ${key}: ${JSON.stringify(value)}` });
        }
    }
};
